import { render } from "./AddReceiverStatisticalPage.vue?vue&type=template&id=58bfa5da&ts=true"
import script from "./AddReceiverStatisticalPage.vue?vue&type=script&lang=ts"
export * from "./AddReceiverStatisticalPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo_YHCT/ZaloOA_CLS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__